import axios from '@/plugins/axios'
import { Message } from 'element-ui'
import isEmpty from "lodash/isEmpty";

export default {
  namespaced: true,

  state: {
    loading: false,
    order_column: 'created_at',
    order_type: 'desc',
    page: 1,
    page_size: 100,
    activeTab: 'campaigns',
    campaigns: [],
    tracks: [],
    labels: [],
    campaignTracks: [],
    labelTracks: [],
    channels:[],
    campaign: {},
    showCampaignModal: false,
    showTrackModal: false,
    showChannelModal: false,
    ShowReportModal: false,
    validation: [],
    campaignReportData: [],
  },

  mutations: {
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setCampaigns(state, payload) {
      state.campaigns = payload
    },
    setCampaignModal(state, payload) {
      state.showCampaignModal = payload
    },
    setTracks(state, payload) {
      state.tracks = payload
    },
    setLabels(state, payload) {
      state.labels = payload
    },
    setCampaignTracks(state, payload) {
      state.campaignTracks = payload
    },
    setLabelTracks(state, payload) {
      state.labelTracks = payload
    },
    setTrackModal(state, payload) {
      state.showTrackModal = payload
    },
    setChannels(state, payload) {
      state.channels = payload
    },
    setChannelModal(state, payload) {
      state.showChannelModal = payload
    },
    setActiveTab(state, payload) {
      state.activeTab = payload
    },
    setValidation(state, payload) {
      state.validation = payload
    },
    setReportsModal(state, payload) {
      state.ShowReportModal = payload
    },
    setCampaingReportData(state, payload) {
      state.campaignReportData = payload
    },
  },

  actions: {
    readCampaigns({ commit, state }) {
      commit('setLoading', true)
      axios.admin
          .get('rev-share/campaigns')
          .then(r => {
            commit('setCampaigns',r.data)
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
    fetchReportByCampaign({ commit }, {campaignId, startDate, endDate}) {
      commit('setLoading', true);
      // Clear the previous report data before fetching new data
      commit('setCampaingReportData', null);  // Reset the campaign report data
  
      axios.admin
        .get(`rev-share/campaigns/${campaignId}`, {
          params: {
            start: startDate,
            end: endDate
          }
        })
        .then(r => {
          commit('setCampaingReportData', r.data);
          commit('setLoading', false);
        })
        .catch(() => {
          commit('setLoading', false);
        });
    },
    insertCampaign({ commit, dispatch }, newCampaign) {
      axios.admin
          .post('rev-share/campaigns', {
            name: newCampaign.name,
            tag: newCampaign.tag,
            description: newCampaign.description,
            start_date: newCampaign.start_date,
            label_share: newCampaign.label_share,
            platform_share: newCampaign.platform_share,
          })
          .then(() => {
            commit('setCampaignModal', false)
            dispatch('readCampaigns')
          })
          .catch(err => {
              if (
                  err.response.data &&
                  !isEmpty(err.response.data.errors.validation)
              ) {
                  commit('setValidation', err.response.data.errors.validation)
              } else if (err.response.data && err.response.data.response.message) {
                  Message({
                      type: 'error',
                      message: err.response.data.response.message
                  })
              }
          })
    },

    readTracks({ commit, state }) {
      commit('setLoading', true)
      axios.admin
          .get('rev-share/tracks')
          .then(r => {
            commit('setTracks',r.data)
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    },
    readLabels({ commit, state }) {
        commit('setLoading', true)
        axios.admin
            .get('rev-share/labels')
            .then(r => {
                commit('setLabels',r.data)
                commit('setLoading', false)
            })
            .catch(() => {
                commit('setLoading', false)
            })
    },
    async readLabelAssets({ commit }, labelName) {
        commit('setLoading', true)
        try {
            const response = await axios.admin.get(`rev-share/labels/${labelName}/tracks`)
            commit('setLabelTracks', response.data)
        } catch (error) {
            console.error('Error fetching tracks:', error)
            Message.error('Failed to load tracks')
        } finally {
            commit('setLoading', false)
        }
    },
    insertTrack({ commit, dispatch }, payload) {
        const { campaign_id, track_ids, cid_share, label_id } = payload;
        axios.admin
            .post(`rev-share/tracks`, {
                campaign_id,
                track_ids,
                cid_share,
                label_id,
            })
            .then(() => {
                commit('setTrackModal', false);
                dispatch('readTracks');
            })
            .catch(err => {
                if (
                    err.response.data &&
                    !isEmpty(err.response.data.errors.validation)
                ) {
                    commit('setValidation', err.response.data.errors.validation)
                } else if (err.response.data && err.response.data.response.message) {
                    Message({
                        type: 'error',
                        message: err.response.data.response.message
                    })
                }
            })
    },
      async fetchCampaignTracks({ commit }, campaignId) {
          commit('setLoading', true)
          try {
              const response = await axios.admin.get(`rev-share/campaigns/${campaignId}/tracks`)
              commit('setCampaignTracks', response.data) // Adjust the path based on your API response
          } catch (error) {
              console.error('Error fetching tracks:', error)
              Message.error('Failed to load tracks')
          } finally {
              commit('setLoading', false)
          }
      },
      insertChannel({ commit, dispatch }, payload) {
          const { campaign_id, track_ids, channel_id,  platform_share, channel_share } = payload;
          axios.admin
              .post(`rev-share/channels`, {
                  campaign_id,
                  track_ids,
                  channel_id,
                  platform_share,
                  channel_share
              })
              .then(() => {
                  commit('setChannelModal', false);
                  dispatch('readChannels');
              })
              .catch(err => {
                  if (
                      err.response.data &&
                      !isEmpty(err.response.data.errors.validation)
                  ) {
                      commit('setValidation', err.response.data.errors.validation)
                  } else if (err.response.data && err.response.data.response.message) {
                      Message({
                          type: 'error',
                          message: err.response.data.response.message
                      })
                      commit('setDialog', false)
                  }
              })
      },
      readChannels({ commit, state }) {
          commit('setLoading', true)
          axios.admin
              .get('rev-share/channels')
              .then(r => {
                  commit('setChannels',r.data)
                  commit('setLoading', false)
              })
              .catch(() => {
                  commit('setLoading', false)
              })
      },
  }
}
